import React from "react";

function Configuration() {
	return <div />;
}

export default Configuration;
